import AcceptRegistrationInvite from "./AcceptRegistrationInvite";
export default AcceptRegistrationInvite;
